import { useTranslation } from "react-i18next";
import { VStack } from "../../styled-system/jsx";
import { buttonRecipe } from "../components/core/basic/Button";

export default function ErrorLayout() {
  const { t } = useTranslation(["common"]);

  return (
    <VStack>
      <h3>{t(($) => $.common["An error occurred."])}</h3>
      <a href="/" className={buttonRecipe()}>
        {t(($) => $.common.actions.Reload)}
      </a>
    </VStack>
  );
}
